import { GqlClientService } from '../common/network/gql-client-service'
import { type OperationResult } from '../common/errors/OperationResult'
import * as op from '../common/errors/OperationResult'
import { UserModel } from './UserModel'

type UserResponse = { user: UserModel }
type MarkTutorialShownResponse = { markTutorialShown: UserModel }

export class UsersApiService {
  constructor(private readonly gqlClientService: GqlClientService) {}

  public async getUser(): Promise<OperationResult<UserModel>> {
    const query = `query {
  user {
    id
    name
    shownTutorials
  }
}`
    const { result: body, error } = await this.gqlClientService.sendGqlRequest<UserResponse>(query)

    if (error) {
      return op.error(error)
    }

    const user = body!.data!.user
    return op.success(user)
  }

  public async markTutorialShown(tutorialId: string): Promise<OperationResult<UserModel>> {
    const query = `mutation($tutorialId: String!) {
  markTutorialShown(tutorialId: $tutorialId) {
    id
    name
    shownTutorials
  }
}`
    const { result: body, error } =
      await this.gqlClientService.sendGqlRequest<MarkTutorialShownResponse>(query, {
        variables: { tutorialId },
      })

    if (error) {
      return op.error(error)
    }
    return op.success(body!.data!.markTutorialShown)
  }
}
